import { render } from "./partManage.vue?vue&type=template&id=5db0150a&scoped=true&ts=true"
import script from "./partManage.vue?vue&type=script&lang=ts"
export * from "./partManage.vue?vue&type=script&lang=ts"

import "./partManage.vue?vue&type=style&index=0&id=5db0150a&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5db0150a"]])

export default __exports__